import { useContext } from 'react';

import { getOrCreateContext } from '@context/singleton-manager';
import type { singletonContextValues } from '@context/singleton-manager';

enum NavItems {
  Accessories = 'accessories',
  Admin = 'admin',
  Cards = 'cards',
  PersonalCardsGraphQL = 'cards/personal',
  CardsTeamGraphQL = 'cards/team',
  Contacts = 'contacts',
  EmailSignatures = 'email-signatures',
  Integrations = 'integrations/card-provisioning',
  PersonalDetails = 'personal-details',
  Presets = 'presets',
  Security = 'security',
  Team = 'team',
  VirtualBackgrounds = 'virtual-backgrounds',
  WorkspaceSettings = 'workspace-settings',
  SingleSignOn = 'team-security',
  Notifications = 'notifications',
  TeamMembers = 'team-members',
  BillingAndSubscription = 'billing-and-subscription',
  TemplatesV3 = 'cards/templates',
  bulkUpload = 'cards/team/bulk-upload',
  Home = 'home',
}

const navigationContext = getOrCreateContext('navigation');

/**
 * Control which navigation item is active at any given time
 */
export default function useNavigationContext(): singletonContextValues {
  return useContext(navigationContext);
}

export { NavItems };
